import { render } from "./Journees.vue?vue&type=template&id=6acbf006&scoped=true"
import script from "./Journees.vue?vue&type=script&lang=js"
export * from "./Journees.vue?vue&type=script&lang=js"

import "./Journees.vue?vue&type=style&index=0&id=6acbf006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acbf006"]])

export default __exports__